componentRegistryInstance.register('real', 'edit', 'hrd.components.form.RealComponent');
componentRegistryInstance.register('real', 'read', 'hrd.components.form.RealComponent');

hrd.components.form.RealComponent = hrd.components.form.AbstractNumericComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.RealComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceEditField: function(field, id, klass) {
		this._super(field, id, klass);
		var seps = this.utils().number().separators();
		var opts = {
			aSep: seps.thousand,
			aDec: seps.decimal,
			mDec: '2'
		};
		if (field.data('minValue') !== undefined) {
			opts.vMin = '' + field.data('minValue');
		}
		if (field.data('maxValue') !== undefined) {
			opts.vMax = '' + field.data('maxValue');
		}
		if (field.data('decimals') !== undefined) {
			opts.mDec = '' + field.data('decimals');
		}
		if (field.data('decimalPadding') !== undefined) {
			opts.aPad = field.data('decimalPadding');
		}
		var formatStyle = field.data('formatStyle');
		if (formatStyle != undefined) {
			var cs = hrd.globals.prefs.tenant.currencySymbol || '&euro;';
			switch (formatStyle) {
				case '%':
				case '-%':
					opts.pSign = 's';
					opts.aSign = ' %';
					break;
				case '%-':
				case '%<-':
					opts.pSign = 'p';
					opts.aSign = '% ';
					break;
				case '$':
				case '-$':
					opts.pSign = 's';
					opts.aSign = ' ' + cs;
					break;
				case '$-':
				case '$<-':
					opts.pSign = 'p';
					opts.aSign = cs + ' ';
					break;
				default:
					console.log('FormatStyle ignored "' + formatStyle + '"');
					opts.aSign = '';
			}
		}
		field.autoNumeric('init', opts);
		field.addClass('right-align');
	},
	initalizeComponentWithUndefined: function(field) {
		field.autoNumeric('set', '0.00');
	}
});